import styled from "styled-components";
import { Paragraph2 } from "../../../../components";

export const ChooseActionStepWrapper = styled.div`
  margin: 18px 0;
  width: 695px;

  ${Paragraph2} {
    font-weight: 700;
  }
`;
